<ng-container *ngIf="isLogged$ | async; else noLogged">
  <ng-container *ngIf="(isAdded$ | async); else notAdded">
    <div class="added__container">
      <button (click)="removePromotionFromCart(); $event.stopPropagation()">
        <svg-icon class="icon" src="assets/icons/trash.svg"></svg-icon>
      </button>
      <button class="added__button" (click)="$event.stopPropagation()">
        <p
          class="added__text"
          [ngClass]="size === 'small' ? 'small__text' : 'large__text'"
        >
          {{
            size === "small"
              ? ("add_promotion_to_cart_button.added" | translate)
              : ("add_promotion_to_cart_button.added_large" | translate)
          }}
        </p>
      </button>
    </div>
  </ng-container>
  <ng-template #notAdded>
    <button
      class="button"
      customButton
      expand="full"
      [size]="size === 'small' ? 'small' : 'large'"
      [disabled]="isAddPromotionToCartLoading$ | async"
      [isLoading]="isAddPromotionToCartLoading$ | async"
      (click)="addPromotionToCart(); $event.stopPropagation()"
    >
      <p *ngIf="price != null && !(isPriceHidden$ | async)" class="price">
        {{ price | localizedCurrency }}
      </p>
      {{
        size === "small"
          ? ("add_promotion_to_cart_button.add" | translate)
          : ("add_promotion_to_cart_button.add_large" | translate)
      }}
    </button>
  </ng-template>
</ng-container>
<ng-template #noLogged>
  <button
    class="button"
    customButton
    expand="full"
    [size]="size === 'small' ? 'small' : 'large'"
    appearance="ghost"
    (click)="goToLogin(); $event.stopPropagation()"
  >
    {{ "add_promotion_to_cart_button.see_price" | translate }}
  </button>
</ng-template>
